
<template>
  <router-view>
    <div  class="header" :class="{header_fixed: this.isHeaderScrolled}">
      <div ref="nav-header_bg" class="header__bg"></div>
      <div class="nav-container">
        <div class="container">
          <nav>
            <div class="flex justify-between align-center">
              <div class="navbar-logo">
                <svg class="logo" @click="reloadPage()" width="38" height="28" viewBox="0 0 38 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.51603 0.134169L2.25889 1.20925V7.99575L5.51603 0.134169ZM2.25889 1.20925L0 2.0685L2.2613 7.99575V1.20925H2.25889ZM20.6726 9.68333L17.5657 15.5493L24.048 18.7472L20.6726 9.68333ZM36.2894 9.6285L38 0.123665L34.2374 3.93341L36.2894 9.6285ZM38 0.123665L34.7429 1.24717L34.2374 3.9305L38 0.123665ZM35.527 13.8542L36.287 9.62967L33.2741 9.0405L35.527 13.8542ZM36.287 9.62967L34.2362 3.93341L33.2765 9.04167L36.287 9.62967ZM35.527 13.8542L33.2765 9.04167L32.0955 15.3189L35.527 13.8542ZM25.454 22.5167L27.319 27.4668L30.8228 22.1002L25.454 22.5167ZM27.319 27.4668L32.1209 25.8078L30.8222 22.0967L27.319 27.4668ZM32.1209 25.8078L33.469 25.3639L30.8228 22.0972L32.1209 25.8078ZM24.0498 18.7495L25.454 22.5178L30.8222 22.0984L24.0498 18.7495ZM32.0973 15.3195L24.0498 18.7495L30.8222 22.0967L32.0973 15.3195ZM33.469 25.3651L35.527 13.8536L30.8222 22.0967L33.469 25.3651ZM35.527 13.8536L32.0931 15.3178L30.8222 22.0967L35.527 13.8536ZM20.6726 9.68333L24.0504 18.7472L27.6254 13.111L20.6726 9.68333ZM19.4234 6.32917L20.6726 9.68333L25.6584 7.58975L19.4234 6.32917ZM20.6726 9.68333L27.6254 13.1116L25.6609 7.58975L20.6726 9.68333ZM19.4234 6.32917L25.6584 7.58975L22.9568 0L19.4234 6.32917ZM19.4234 6.32917L22.9568 0L17.737 1.77508L19.4234 6.32917ZM17.5657 15.5499L20.6726 9.68333L17.7394 8.20575L17.5657 15.5499ZM20.6726 9.68333L19.4234 6.32917L17.7394 8.20633L20.6726 9.68333ZM19.4234 6.32917L17.7345 1.7745V8.20633L19.4234 6.32917ZM17.5657 15.5499L17.7394 8.20633L13.905 13.7439L17.5657 15.5499ZM5.61737 16.7598L9.89207 28L13.8953 20.8483L5.61737 16.7598ZM9.89207 28L13.8953 26.6257V20.8507L9.89207 28ZM13.9032 13.7439L5.61555 16.7598L13.8953 20.8483L13.9032 13.7439ZM17.5638 15.5523L13.9032 13.7439L13.8971 20.8483L17.5638 15.5523ZM5.51603 0.134169L2.25889 7.99575L9.91921 11.7781L5.51603 0.134169ZM2.25889 7.99575L5.61555 16.7603L9.91981 11.7787L2.25889 7.99575ZM5.61555 16.7603L13.9032 13.7445L9.92222 11.7787L5.61555 16.7603Z" fill="white"/>
                </svg>
                <div class="internationalization_mobile flex align-center">
                  <button
                      :class="{'internationalization-button__active': this.$root.$i18n.locale === button.name,
                      'internationalization-button-black__active': this.isHeaderScrolled && this.$root.$i18n.locale === button.name}"
                      v-for="(button, index) in internationalizationButtons"
                      :key="button.id"
                      @click="setWebsiteLanguage(button.name, index)"
                      :ref="'internationalization-button' + button.id">
                    {{button.name.toUpperCase()}}
                  </button>
                </div>
              </div>
              <div class="mobile_messagers">
                <a class="viber_btn" href="https://wa.me/380668089011" :style="[this.isHeaderScrolled? 'color: #000': 'color: #fff']">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 24L2.687 17.837C1.646 16.033 1.099 13.988 1.1 11.891C1.103 5.335 6.438 0 12.993 0C16.174 0.001 19.16 1.24 21.406 3.488C23.651 5.736 24.887 8.724 24.886 11.902C24.883 18.459 19.548 23.794 12.993 23.794C11.003 23.793 9.042 23.294 7.305 22.346L1 24ZM7.597 20.193C9.273 21.188 10.873 21.784 12.989 21.785C18.437 21.785 22.875 17.351 22.878 11.9C22.88 6.438 18.463 2.01 12.997 2.008C7.545 2.008 3.11 6.442 3.108 11.892C3.107 14.117 3.759 15.783 4.854 17.526L3.855 21.174L7.597 20.193ZM18.984 14.729C18.91 14.605 18.712 14.531 18.414 14.382C18.117 14.233 16.656 13.514 16.383 13.415C16.111 13.316 15.913 13.266 15.714 13.564C15.516 13.861 14.946 14.531 14.773 14.729C14.6 14.927 14.426 14.952 14.129 14.803C13.832 14.654 12.874 14.341 11.739 13.328C10.856 12.54 10.259 11.567 10.086 11.269C9.913 10.972 10.068 10.811 10.216 10.663C10.35 10.53 10.513 10.316 10.662 10.142C10.813 9.97 10.862 9.846 10.962 9.647C11.061 9.449 11.012 9.275 10.937 9.126C10.862 8.978 10.268 7.515 10.021 6.92C9.779 6.341 9.534 6.419 9.352 6.41L8.782 6.4C8.584 6.4 8.262 6.474 7.99 6.772C7.718 7.07 6.95 7.788 6.95 9.251C6.95 10.714 8.015 12.127 8.163 12.325C8.312 12.523 10.258 15.525 13.239 16.812C13.948 17.118 14.502 17.301 14.933 17.438C15.645 17.664 16.293 17.632 16.805 17.556C17.376 17.471 18.563 16.837 18.811 16.143C19.059 15.448 19.059 14.853 18.984 14.729Z" fill="currentColor" />
                  </svg>
                </a>
                <a class="tg_btn" href="https://t.me/+380668089011" :style="[this.isHeaderScrolled? 'color: #000': 'color: #fff']">
                  <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.64987 8.60987C8.09231 5.78741 12.3883 3.92667 14.5378 3.02765C20.675 0.460774 21.9503 0.0148807 22.7815 0.000156987C22.9643 -0.00308132 23.3731 0.0424773 23.6379 0.25852C23.8614 0.440943 23.9229 0.687369 23.9524 0.860326C23.9818 1.03328 24.0185 1.42728 23.9893 1.73514C23.6568 5.249 22.2177 13.7762 21.4856 17.7118C21.1758 19.3771 20.5658 19.9354 19.9753 19.9901C18.6919 20.1088 17.7174 19.1372 16.4744 18.3179C14.5294 17.0358 13.4305 16.2377 11.5425 14.9867C9.36064 13.5408 10.7751 12.7462 12.0185 11.4475C12.344 11.1076 17.9985 5.93584 18.1079 5.46668C18.1216 5.40801 18.1343 5.18929 18.0051 5.0738C17.8759 4.95831 17.6851 4.9978 17.5475 5.02921C17.3524 5.07373 14.2452 7.1389 8.22584 11.2247C7.34386 11.8337 6.545 12.1304 5.82924 12.1149C5.04018 12.0977 3.52233 11.6663 2.39397 11.2974C1.00999 10.8451 -0.0899676 10.6059 0.00581422 9.83761C0.0557033 9.43745 0.603723 9.0282 1.64987 8.60987Z" fill="currentColor"/>
                  </svg>
                </a>
              </div>
              <div @click="openMenu()" class="navbar-burger" id="dropdownMenuIcon-js">
                <div class="dropdown-menu_icon" id="openIcon">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div class="navbar__list">
                <ul>
                  <li class="nav-item" v-for="(menu, index) in menuHeaderList" :key='index'>
                    <router-link class="navbar-link header_light" aria-current="page" :to="menu.path">{{ $t(menu.name) }}</router-link>
                  </li>
                  <li>
                    <Link class="navbar-link header_light" :to="blogUrl">{{ $t('main_page.header.nav[2]')}}</Link>
                  </li>
                </ul>
                <div v-for="(contact, i) in contacts" :key="i">
                  <a
                      @click="goToPage(contact.path)"
                      class="nav__btn"
                      aria-current="page"
                  >
                    {{ $t(contact.name) }}
                    <svg width="31" height="8" viewBox="0 0 31 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M30.3536 4.35355C30.5488 4.15829 30.5488 3.84171 30.3536 3.64645L27.1716 0.464466C26.9763 0.269204 26.6597 0.269204 26.4645 0.464466C26.2692 0.659728 26.2692 0.976311 26.4645 1.17157L29.2929 4L26.4645 6.82843C26.2692 7.02369 26.2692 7.34027 26.4645 7.53553C26.6597 7.7308 26.9763 7.7308 27.1716 7.53553L30.3536 4.35355ZM0 4.5H30V3.5H0V4.5Z" fill="white"/>
                    </svg>
                  </a>
                </div>
                <a class="viber_btn" href="https://wa.me/380668089011" :style="[this.isHeaderScrolled? 'color: #000': 'color: #fff']">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 24L2.687 17.837C1.646 16.033 1.099 13.988 1.1 11.891C1.103 5.335 6.438 0 12.993 0C16.174 0.001 19.16 1.24 21.406 3.488C23.651 5.736 24.887 8.724 24.886 11.902C24.883 18.459 19.548 23.794 12.993 23.794C11.003 23.793 9.042 23.294 7.305 22.346L1 24ZM7.597 20.193C9.273 21.188 10.873 21.784 12.989 21.785C18.437 21.785 22.875 17.351 22.878 11.9C22.88 6.438 18.463 2.01 12.997 2.008C7.545 2.008 3.11 6.442 3.108 11.892C3.107 14.117 3.759 15.783 4.854 17.526L3.855 21.174L7.597 20.193ZM18.984 14.729C18.91 14.605 18.712 14.531 18.414 14.382C18.117 14.233 16.656 13.514 16.383 13.415C16.111 13.316 15.913 13.266 15.714 13.564C15.516 13.861 14.946 14.531 14.773 14.729C14.6 14.927 14.426 14.952 14.129 14.803C13.832 14.654 12.874 14.341 11.739 13.328C10.856 12.54 10.259 11.567 10.086 11.269C9.913 10.972 10.068 10.811 10.216 10.663C10.35 10.53 10.513 10.316 10.662 10.142C10.813 9.97 10.862 9.846 10.962 9.647C11.061 9.449 11.012 9.275 10.937 9.126C10.862 8.978 10.268 7.515 10.021 6.92C9.779 6.341 9.534 6.419 9.352 6.41L8.782 6.4C8.584 6.4 8.262 6.474 7.99 6.772C7.718 7.07 6.95 7.788 6.95 9.251C6.95 10.714 8.015 12.127 8.163 12.325C8.312 12.523 10.258 15.525 13.239 16.812C13.948 17.118 14.502 17.301 14.933 17.438C15.645 17.664 16.293 17.632 16.805 17.556C17.376 17.471 18.563 16.837 18.811 16.143C19.059 15.448 19.059 14.853 18.984 14.729Z" fill="currentColor" />
                  </svg>
                </a>
                <a class="tg_btn" href="https://t.me/+380668089011" :style="[this.isHeaderScrolled? 'color: #000': 'color: #fff']">
                  <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.64987 8.60987C8.09231 5.78741 12.3883 3.92667 14.5378 3.02765C20.675 0.460774 21.9503 0.0148807 22.7815 0.000156987C22.9643 -0.00308132 23.3731 0.0424773 23.6379 0.25852C23.8614 0.440943 23.9229 0.687369 23.9524 0.860326C23.9818 1.03328 24.0185 1.42728 23.9893 1.73514C23.6568 5.249 22.2177 13.7762 21.4856 17.7118C21.1758 19.3771 20.5658 19.9354 19.9753 19.9901C18.6919 20.1088 17.7174 19.1372 16.4744 18.3179C14.5294 17.0358 13.4305 16.2377 11.5425 14.9867C9.36064 13.5408 10.7751 12.7462 12.0185 11.4475C12.344 11.1076 17.9985 5.93584 18.1079 5.46668C18.1216 5.40801 18.1343 5.18929 18.0051 5.0738C17.8759 4.95831 17.6851 4.9978 17.5475 5.02921C17.3524 5.07373 14.2452 7.1389 8.22584 11.2247C7.34386 11.8337 6.545 12.1304 5.82924 12.1149C5.04018 12.0977 3.52233 11.6663 2.39397 11.2974C1.00999 10.8451 -0.0899676 10.6059 0.00581422 9.83761C0.0557033 9.43745 0.603723 9.0282 1.64987 8.60987Z" fill="currentColor"/>
                  </svg>
                </a>
                <div class="internationalization flex align-center">
                  <button :class="{'internationalization-button__active': this.$root.$i18n.locale === button.name, 'internationalization-button-black__active': this.isHeaderScrolled && this.$root.$i18n.locale === button.name}" v-for="(button, index) in internationalizationButtons" :key="button.id" @click="setWebsiteLanguage(button.name, index)" :ref="'internationalization-button' + button.id">
                    {{button.name.toUpperCase()}}
                  </button>
                </div>
              </div>

              <div class="dropdown-menu_list" id="dropdownMenuList-js">
                <ul>
                  <li v-for="(mobileMenu, index) in mobileMenuHeader" :key="index">
                    <a @click="goToPage(mobileMenu.path)" >{{mobileMenu.name}}</a>
                  </li>
                  <li>
                    <Link class="navbar-link header_light" :to="blogUrl">Blog</Link>
                  </li>
                </ul>
                <div v-for="(caseButton, index) in casesButton" :key="index">
                  <a
                      @click="goToPage(caseButton.path)"
                      class="nav__btn"
                      aria-current="page"
                  >
                    {{caseButton.name}}
                    <svg width="31" height="8" viewBox="0 0 31 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M30.3536 4.35355C30.5488 4.15829 30.5488 3.84171 30.3536 3.64645L27.1716 0.464466C26.9763 0.269204 26.6597 0.269204 26.4645 0.464466C26.2692 0.659728 26.2692 0.976311 26.4645 1.17157L29.2929 4L26.4645 6.82843C26.2692 7.02369 26.2692 7.34027 26.4645 7.53553C26.6597 7.7308 26.9763 7.7308 27.1716 7.53553L30.3536 4.35355ZM0 4.5H30V3.5H0V4.5Z" fill="white"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </router-view>
</template>

<script>
import Link from "./Link";

export default {
  data() {
    return {
      menuHeaderList: [
        {name: 'main_page.header.nav[0]', path: '/cases/'},
        {name: 'main_page.header.nav[1]', path: '/work-approach/'}
      ],
      mobileMenuHeader: [
        {name: 'Contact', path: '/contacts/'},
        {name: 'Work Approach', path: '/work-approach/'}
      ],
      contacts: [
        {name: 'main_page.header.button', path: '/contacts/'}
      ],
      casesButton: [
        {name: 'View cases', path: '/cases/'}
      ],
      internationalizationButtons: [
        {id: 1, name: 'en', isWebsiteLanguage: false},
        {id: 2, name: 'ua', isWebsiteLanguage: false}
      ],
      isHeaderScrolled: false,
    }
  },
  computed: {
    blogUrl() {
      return this.$i18n.locale === 'en' 
        ? 'https://blog.webmil.eu/' 
        : 'https://blog-ua.webmil.eu/';
    }
  },
  components: {
    Link
  },
  methods: {
    openMenu() {
      let menuList = document.getElementById('dropdownMenuList-js')
      let openIcon = document.getElementById('openIcon')
      let body = document.querySelector("body");
      menuList.classList.toggle('open');
      openIcon.classList.toggle('icon-trigger');
      body.classList.toggle("lock");
    },
    goToPage(path){
      this.$router.push(path);
      let body = document.querySelector("body");
      let menuList = document.getElementById('dropdownMenuList-js')
      let openIcon = document.getElementById('openIcon')
      if(body.classList.contains("lock")){
        menuList.classList.remove('open');
        openIcon.classList.remove('icon-trigger');
        body.classList.remove("lock");
      }
    },


    reloadPage() {
      window.location.reload();
    },


    checkHeaderPosition(){
      if(!this.$refs["nav-header_bg"]){
        return false
      }

      if(window.scrollY > 0 && window.scrollY <= 100){
        this.isHeaderScrolled = true
        this.$refs["nav-header_bg"].style.opacity = "0.7"
      } else if(window.scrollY > 100 && window.scrollY <= 200) {
        this.$refs["nav-header_bg"].style.opacity = "0.9"
      } else if(window.scrollY > 200) {
        this.$refs["nav-header_bg"].style.opacity = "1"
      } else {
        this.isHeaderScrolled = false
      }
    },


    setWebsiteLanguage(language){
      this.$root.$i18n.locale = language;
      console.log(language);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.checkHeaderPosition);
  },
  updated() {

  }
}
</script>

<style lang="scss">
@import "../base/styles/global";
.mobile_messagers{
  display: none;
  @media(max-width: 991px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 20px;
  }
}
.tg_btn, .viber_btn{
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.viber_btn{
  margin-left: 10px;
}

.navbar-link{
  transition: 0.4s color;

  &:hover{
    color: #688E93;
  }
}

.logo_dark > path{
  fill: rgba(46, 49, 57, 1);
}

.navbar-logo{
  cursor: pointer;
}

.opacity{
  opacity: 0.2;
}

.lock{
  overflow: hidden;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}

.navbar-burger{
  display: flex;
}

.header{
  position: fixed !important;
  z-index: 1000;
  width: 100%;
}
.header_light {
  font-size: 20px;
  line-height: 28px;
  color: #fff;
  transition: 0.4s color;
}

.nav__btn{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  min-height: 45px;
  min-width: 190px;
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
  outline: none;
  margin-left: 60px;
  font-style: normal;
  transition: 0.4s all;

  svg{
    margin-left: 20px;
  }

  svg > path{
    transition: 0.4s all;
    fill: #fff;
  }

  @media (any-hover: hover) {
    &:hover  {
      color: rgba(46, 49, 57, 1) !important;
      background: #fff;
      border: 1px solid #fff;

      svg > path{
        fill: rgba(46, 49, 57, 1);
      }
    }
  }

  &:active{
    color: #fff !important;
    background: transparent;
    border: 2px solid #fff;

    svg > path{
      fill: #fff;
    }
  }

  //@media(max-width: 1399px){
  //  margin-left: 100px;
  //}
  //
  //@media(max-width: 1199px){
  //  margin-left: 40px;
  //}

  @media(max-width: 991px){
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    min-width: 220px;
    min-height: 60px;
    margin-left: 0px;
    background-color: #fff;
    color: rgba(46, 49, 57, 1);
    text-transform: capitalize;

    svg > path{
      fill: rgba(46, 49, 57, 1);
    }
  }
}

.header__bg{
  transition: 0.7s all;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -3;
}

@media(min-width: 991px){
  .internationalization_mobile{
    display: none !important;
  }
}

.internationalization_mobile{
  position: relative;
  z-index: 5;
  margin-left: 20px;
  button{
    background-color: transparent;
    border: none;
    padding: 0;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #83898B;
    transition: 0.3s all;
    @media(max-width: 575px){
      font-size: 14px;
      line-height: 24px;
    }

    &:not(:first-child){
      margin-left: 10px;
    }
  }

  .internationalization-button__active{
    font-weight: 700;
    color: #FFF;
  }

  .internationalization-button-black__active{
    color: #2E3139 !important;
  }
}

.internationalization{
  margin-left: 60px;
  .internationalization-button__active{
    font-weight: 700;
    color: #FFF;
  }

  .internationalization-button-black__active{
    color: #2E3139 !important;
  }

  button{
    background-color: transparent;
    border: none;
    padding: 0;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #83898B;
    transition: 0.3s color;
  }
  button:nth-child(1){
    margin-right: 10px;
  }
  @media(max-width: 991px){
    display: none !important;
  }
}
.navbar__list{
  display: flex;
}

@media(max-width: 991px){
  .navbar__list{
    display: none;
  }
}

.header_fixed{
  transition: 0.4s all;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  .header__bg{
    background: #fff;
  }

  .nav-container{
    @media (max-width: 991px) {
      padding: 20px 0px;
    }
    @media(max-width: 575px){
      padding: 16px 0px;
    }
  }

  .navbar-logo{
    svg > path{
      fill: #2E3139;
    }
  }

  .opacity{
    opacity: 1;
  }
  .opacity > path{
    fill: #fff;
  }

  .navbar-link{
    color: rgba(46, 49, 57, 1);

    @media (any-hover: hover) {
      &:hover{
        color: #688E93;
      }
    }

    @media(max-width: 991px){
      color: #fff;
    }
  }

  .nav__btn{
    @media(min-width: 992px) {
      color: rgba(46, 49, 57, 1) !important;
      border: 1px solid rgba(46, 49, 57, 1);
      svg > path {
        fill: rgba(46, 49, 57, 1);
      }

      @media(max-width: 991px) {
        color: #fff !important;
        border: 1px solid #fff;

        svg > path {
          fill: #fff;
        }
      }

      @media (any-hover: hover) {
        &:hover {
          color: #fff !important;
          background: rgba(46, 49, 57, 1);
          border: 1px solid rgba(46, 49, 57, 1);

          svg > path {
            fill: #fff;
          }
        }
      }

      &:active {
        color: rgba(46, 49, 57, 1) !important;
        background: #fff;
        border: 2px solid rgba(46, 49, 57, 1);

        svg > path {
          fill: rgba(46, 49, 57, 1);
        }
      }
    }
  }

  .navbar-burger{
    .dropdown-menu_icon{
      span{
        background: rgba(46, 49, 57, 1);
      }
    }

    .icon-trigger{
      transition: 0.3s all;
      span{
        background: #fff;
      }
    }
  }
}

.nav-container {
  max-width: 1320px;
  margin: 0 auto;
  padding: 27px 0px;

  @media (max-width: 991px) {
    padding: 20px 0px;
  }

  ul {
    display: flex;
    align-items: center;
    @media (max-width: 991px) {
      flex-direction: column;
      padding-top: 120px;
    }

    li:not(:last-child){
      margin-right: 30px;
    }

    li{
      @media (max-width: 991px) {
        &:not(:last-child){
          margin-right: 0px;
          margin-bottom: 42px;
        }
      }
    }
  }
}

@media(min-width: 992px){
  .dropdown-menu_list{
    display: none;
  }
}

@media(max-width: 991px){
  .dropdown-menu_list {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: -100%;
    transition: 0.3s left;
    padding-bottom: 66px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    @supports (backdrop-filter: blur(80px)) {
      & {
        backdrop-filter: blur(80px);
        background: rgba(0, 0, 0, 0.7);
      }
    }

    @supports not (backdrop-filter: blur(80px)){
      & {
        background: rgba(0, 0, 0, 1);
      }
    }

    ul{
      flex: 1 1 auto;
    }

    ul a {
      font-size: 20px;
      line-height: 28px;

    }

    li {
      color: white;
      padding: 5px 0;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        cursor: pointer;
      }
    }

    @media (min-width: 992px) {
      position: relative;
      flex-direction: row;
    }
  }

  .open {
    height: 100vh;
    left: 0;
    color: #fff;
  }

  .dropdown-menu_icon {
    width: 25px;
    height: 25px;
    cursor: pointer;
    color: #fff;
    z-index: 10;
  }
}

.nav{
  position: relative;
  z-index: 1;
}


.ml-auto {
  margin-left: auto;
}

.header {
  position: relative;
  z-index: 2;
  .btn__black{
    color: #2E3139 !important;
    border: 1px solid #2E3139;
  }
}

.navbar {
  padding-top: 27px !important;
}

.btn-contact {
  margin-left: 120px;
  border: 1px solid #fff;
  padding: 8px 70px 8px 20px;
}

.dropdown-menu_icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  span{
    @media (max-width: 991px) {
      display: block;
      position: absolute;
      right: 0;
      width: 26px;
      height: 1px;
      background-color: #fff;
      padding-right: 26px;
      transition: 0.3s all;

      &:first-child {
        top: 5px;
      }
      &:last-child {
        top: 19px;
      }
    }
  }
}

.icon-trigger{
  @media(max-width: 991px){
    span:nth-child(1){
      top: 10px;
      transform: rotate(45deg);
    }
    span:nth-child(2){
      opacity: 0;
      right: -20px;
    }
    span:nth-child(3){
      top: 10px;
      transform: rotate(-45deg);
    }
  }
}

.navbar-toggler {
  border: none;

  &:focus {
    box-shadow: none;
    border-color: transparent;
  }
}
</style>
